import { createSlice } from "@reduxjs/toolkit";

const tableauLibraryItems = [];

const tableauLibrarySliceData = createSlice({
    name: "tableauLibrarySliceData",
    initialState: { tableauLibraryItems },
    reducers: {
        resetTableauLibraryItems(state) {
            state.tableauLibraryItems = tableauLibraryItems
        },
        setTableauLibraryItems(state, action) {
            state.tableauLibraryItems = action.payload
        },
    }
})

export const { setTableauLibraryItems, resetTableauLibraryItems } = tableauLibrarySliceData?.actions;

export default tableauLibrarySliceData?.reducer;